module.exports = __webpack_public_path__ + "img/layout_bottom_4.47d76ccf.png";